// removed by extract-text-webpack-plugin
module.exports = {"teamGridWrapper":"team__teamGridWrapper--3DsQe","afcGroup":"team__afcGroup--3dP4i","nfcGroup":"team__nfcGroup--OJjIS","teamsColumn":"team__teamsColumn--9Fqo8","teamWrapper":"team__teamWrapper--r0q_z","teamLogo":"team__teamLogo--1RjyM","teamText":"team__teamText--2Ov1h","teamsDivisionName":"team__teamsDivisionName--26wYb","linksWrapper":"team__linksWrapper--1wSTS","subLinksWrapper":"team__subLinksWrapper--3IbLr","verticalLine":"team__verticalLine--2XpsI"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Team/team.css
// module id = htJr
// module chunks = 5 22